import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=59f74f8a&"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports